import { MdAutorenew, MdCloudUpload, MdWarning } from 'react-icons/md';
import { Icon, Pill } from '@nbirl/nbi-common-ui-libs';

import { UploadStatus } from '../../../../shared/enum';
import { UploadError } from '../../../../shared/models';

const getVariant = (status: UploadStatus): 'red' | 'gray' =>
  status === UploadStatus.REJECTED ? 'red' : 'gray';

const getLabel = (status: UploadStatus, error?: UploadError) => {
  switch (status) {
    case UploadStatus.UPLOADING:
      return 'Uploading';
    case UploadStatus.REJECTED:
      return error?.message || 'Failed to upload';
    default:
      return 'Queued';
  }
};

const getIcon = (status: UploadStatus, className: string) => {
  switch (status) {
    case UploadStatus.UPLOADING:
      return <MdCloudUpload className={className} />;
    case UploadStatus.REJECTED:
      return <MdWarning className={className} />;
    default:
      return <MdAutorenew className={className} />;
  }
};

type UploadStatusLabelProps = { status: UploadStatus; error?: UploadError };

export const UploadStatusLabel: React.FC<UploadStatusLabelProps> = ({
  status,
  error,
}) => (
  <Pill
    variant={getVariant(status)}
    className="inline-flex items-center align-start"
  >
    <Icon size="16" icon={getIcon(status, 'mr-1')} />
    {getLabel(status, error)}
  </Pill>
);
